import { VariableType } from 'json-to-graphql-query';

import { EventFeeFunctions } from '@/enums/eventFeeFunctions.enum';
import { EventFunctions } from '@/enums/eventFunctions.enum';
import { TableName } from '@/enums/tableName.enum';
import { EventsArgs, EventsVariables } from './queryVariables/events';
import { Resource } from './resource';

/**
 * Resource wydarzeń
 *
 * @export
 * @class EventsResource
 * @extends {Resource}
 */
export class EventsResource extends Resource {
  /**
   * Pobiera wydarzenia grupy treningowej
   *
   * @param {number} id
   * @param {Date} start
   * @param {Date} end
   * @memberof EventsResource
   */
  public teamEvents(teamId: number, start: Date, end: Date) {
    return this.events(teamId, start, end, 'teamId', EventFunctions[TableName.Team]);
  }

  /**
   * Pobiera wydarzenia klubu
   *
   * @param {number} clubId
   * @param {Date} start
   * @param {Date} end
   * @returns
   * @memberof EventsResource
   */
  public clubEvents(clubId: number, start: Date, end: Date) {
    return this.events(clubId, start, end, 'clubId', EventFunctions[TableName.Club]);
  }

  /**
   * Pobiera wydarzenia użytkownika
   *
   * @param {number} profileId
   * @param {Date} start
   * @param {Date} end
   * @returns
   * @memberof EventsResource
   */
  public userEvents(profileId: number, start: Date, end: Date) {
    return this.events(profileId, start, end, 'profileId', EventFunctions[TableName.User]);
  }

  /**
   * Pobiera wydarzenia składek grupy treningowej
   *
   * @param {number} id
   * @param {Date} start
   * @param {Date} end
   * @memberof EventsResource
   */
  public teamFees(teamId: number, start: Date, end: Date) {
    return this.events(teamId, start, end, 'teamId', EventFeeFunctions[TableName.Team]);
  }

  /**
   * Pobiera wydarzenia składek klubu
   *
   * @param {number} clubId
   * @param {Date} start
   * @param {Date} end
   * @returns
   * @memberof EventsResource
   */
  public clubFees(clubId: number, start: Date, end: Date) {
    return this.events(clubId, start, end, 'clubId', EventFeeFunctions[TableName.Club]);
  }

  /**
   * Pobiera wydarzenia składek użytkownika
   *
   * @param {number} profileId
   * @param {Date} start
   * @param {Date} end
   * @returns
   * @memberof EventsResource
   */
  public userFees(profileId: number, start: Date, end: Date) {
    return this.events(profileId, start, end, 'profileId', EventFeeFunctions[TableName.User]);
  }

  /**
   * Wydarzenia
   *
   * @private
   * @param {number} id
   * @param {string} paramName
   * @param {string} eventFunction
   * @param {Date} start
   * @param {Date} end
   * @returns {Promise<string>}
   * @memberof EventsResource
   */
  private events(id: number, start: Date, end: Date, paramName: string, eventFunction: string): Promise<string> {
    const query = this.prepareOptions({
      query: {
        __variables: { [paramName]: 'Int!', ...EventsVariables },
        [eventFunction]: {
          __args: { [paramName]: new VariableType(paramName), ...EventsArgs },
          date: true,
          schedule: {
            name: true,
            description: true,
            hour: true,
            minute: true,
            duration: true
          },
          container: {
            id: true,
            name: true,
            description: true
          }
        }
      }
    });
    return this.query({ query, variables: { start, end, [paramName]: id } }, eventFunction);
  }
}
export const eventsResource = new EventsResource();
